/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import styled from "styled-components"

import PanelShare from "./PanelShare"
import Button from "@/containers/MoneyFortune/View/homeWEB3/Button"

export default function BBlock({
  img,
  setShowPanel,
  setPanelContent,
  roleID,
  type,
  resultImg,
  reset,
  API,
  GetAndShare,
  phone,
  setPhone,
  setAnswerInfoHandler,
  saveAnswerInfoToAPI,
  showPanel,
  getTraitId
}) {
  const [canSubmit, setCanSubmit] = useState(true)

  const GotoGetNFT = () => {
    if (canSubmit === true) {
      saveAnswerInfoToAPI()
      setCanSubmit(false)
    }
    return
  }

  useEffect(() => {
    setAnswerInfoHandler()
  }, [])

  return (
    <Wrapper>
      <BottomWrapper className="BottomWrapper">
        <LeftWrapper>
          <Awrapper href={GetAndShare.resultToUrl} target="blank">
            <a
              href="https://web3plus.bnext.com.tw/member/temporary"
              target="_blank"
              style={{ width: "100%" }}
            >
              <Button onClick={GotoGetNFT} content={"註冊會員 免費領 NFT"} />
            </a>
          </Awrapper>
        </LeftWrapper>
        <RightWrapper>
          <Button
            type="secondary"
            onClick={() => {
              setShowPanel("open")
              setPanelContent(
                <PanelShare
                  roleID={getTraitId(roleID)}
                  resultImg={resultImg}
                  GetAndShare={GetAndShare}
                />
              )
            }}
            content={"分享圖片"}
          />
          {/* <BackBtnWrapperMobile onClick={reset}>重新測驗</BackBtnWrapperMobile> */}
        </RightWrapper>
      </BottomWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
`

const BottomWrapper = styled.div`
  display: flex;
  width: 100%;
  z-index: 3;
  gap: 20px;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`
const LeftWrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  gap: 20px;
`

const RightWrapper = styled.div`
  display: flex;
  cursor: pointer;
  gap: 20px;
  flex: 0.8;
  @media (max-width: 1200px) {
    order: 1;
  }
`

const Awrapper = styled.a`
  width: 100%;
  display: flex;
`
